import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { withTranslation } from 'react-i18next';
import GeofenceMap from 'src/components/administration/geofence-calculation/components/geofence-map';
import { Currency, Entities, TOMCAT_URL } from 'src/common';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { MenuItem } from 'material-ui';
import SelectField from 'material-ui/SelectField';
import Money from 'src/common/entity/basic-types/Money';
import ZoneCalculationAdministrationItems from 'src/components/administration/zone-calculation/components/zone-calculation-administration-items';
import CircularProgress from 'material-ui/CircularProgress';
import ZoneCalculationForm from 'src/components/administration/zone-calculation/components/zone-calculation-form';

class ZoneCalculationAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            activeGeofence: [],
            startedFetching: false,
            selectedCountryCalc: null,
        };
    }

    componentWillMount() {
        this.setState({ startedFetching: true });
        const { selectedCompany } = this.props;

        this.props.fetchOwnBusCompany(selectedCompany);
        this.props.fetchByCompanyId(Entities.COUNTRY_CALCULATION, selectedCompany);

        this.props.search(Entities.GEOFENCE_AREA, `get-all`, 0, undefined, true);
    }

    handleSubmit(data) {
        const { save, t, busCompany } = this.props;

        const request = { ...data };
        request.countryCalculation = `${TOMCAT_URL}api/${Entities.COUNTRY_CALCULATION.repository}/${this.state.selectedCountryCalc.id}`;
        request.zoneA = `${TOMCAT_URL}api/${Entities.GEOFENCE_AREA.repository}/${data.zoneA.id}`;
        request.company = `${TOMCAT_URL}api/${Entities.BUS_COMPANY.repository}/${this.props.busCompany.entity.id}`;

        if (request.zoneB !== undefined)
            request.zoneB = `${TOMCAT_URL}api/${Entities.GEOFENCE_AREA.repository}/${data.zoneB.id}`;
        save(request, Entities.ZONE_CALCULATION).then(response => {
            this.props.addNotification(
                t('zone_calculation.response.success.title'),
                t('zone_calculation.response.success.content'),
                'success',
                'tr',
            );
        });
    }

    componentDidMount() {
        this.waitForGoogle();
    }

    waitForGoogle() {
        if (window.google && window.google.maps) {
            this.setState({ googleReady: true });
            return;
        }
        this.pollGoogle();
    }

    pollGoogle() {
        const interval = setInterval(() => {
            if (window.google && window.google.maps) {
                clearInterval(interval);
                this.setState({ googleReady: true });
            }
        }, 100);
    }

    render() {
        const { geofenceCalculations, geofenceAreas, countryCalculations, t, busCompany, addNotification } = this.props;

        const location = busCompany && busCompany.entity && busCompany.entity.location;
        const lat = location ? location.lat : undefined;
        const lng = location ? location.lng : undefined;
        const centerMap = lat !== undefined && lng !== undefined ? { lat, lng } : null;

        const finishFetching =
            this.state.startedFetching &&
            !geofenceAreas.isFetching &&
            !geofenceCalculations.isFetching &&
            !busCompany.isFetching &&
            !countryCalculations.isFetching;
        if (!finishFetching) return <CircularProgress />;

        if (busCompany.entity && !busCompany.entity.geoZoneFlatRateCalculationEnabled) {
            this.props.push('/administration/countries');
        }
        let initialValues = {
            flatRate: new Money(undefined, Currency.EUR),
        };

        return (
            <>
                <div className="col-md-12">
                    <div className="col-md-6">
                        <SelectField
                            value={this.state.selectedCountryCalc}
                            onChange={(event, index, item) => {
                                this.setState({
                                    selectedCountryCalc: item,
                                });
                                if (item.id)
                                    this.props.search(
                                        Entities.ZONE_CALCULATION,
                                        `get-calculations/${item.id}/operator`,
                                        0,
                                        undefined,
                                        true,
                                        () => {
                                            this.setState({ startedFetching: false });
                                        },
                                    );
                            }}
                            floatingLabelText={t('geofence.form.select_country_calc')}
                            fullWidth={true}
                            floatingLabelFixed={true}>
                            {countryCalculations.items.map(item => (
                                <MenuItem key={item.id} value={item} primaryText={item.name} />
                            ))}
                        </SelectField>
                        {this.state.selectedCountryCalc && (
                            <ZoneCalculationForm
                                t={this.props.t}
                                form={'zoneCalculationCreationFormCreate'}
                                geofenceAreas={geofenceAreas.items}
                                asyncCheckDuplicate={this.props.asyncCheckDuplicate}
                                initialValues={initialValues}
                                busCompany={busCompany}
                                selectedCountryCalc={this.state.selectedCountryCalc}
                                setShowOnMap={geofenceArea => {
                                    this.setState({ activeGeofence: geofenceArea.boundaryList });
                                }}
                                onSubmit={this.handleSubmit}
                                isCreate={true}
                            />
                        )}
                    </div>

                    <div className="col-md-6">
                        {this.state.googleReady && (
                            <GeofenceMap
                                containerElement={<div style={{ height: `350px`, width: '100%' }} />}
                                mapElement={<div style={{ height: `100%` }} />}
                                loadingElement={<div style={{ height: `100%` }} />}
                                activeGeofence={this.state.activeGeofence}
                                zoom={10}
                                center={centerMap}
                            />
                        )}
                    </div>
                </div>

                <div className="col-md-12">
                    {this.state.selectedCountryCalc !== null && (
                        <ZoneCalculationAdministrationItems
                            t={t}
                            zoneCalculations={this.props.zoneCalculations}
                            deleteById={this.props.deleteById}
                            geofenceAreas={geofenceAreas.items}
                            busCompany={busCompany}
                            selectedCountryCalc={this.state.selectedCountryCalc}
                            setShowOnMap={geofenceArea => {
                                this.setState({ activeGeofence: geofenceArea.boundaryList });
                            }}
                            addNotification={addNotification}
                            handleSubmit={this.handleSubmit}
                        />
                    )}
                </div>
            </>
        );
    }
}

export default withTranslation()(composeModalActions(ZoneCalculationAdministration));
